import { useEffect, useState } from 'react';
import { getRemainingSkeletonDelay, markSkeletonSeen } from '../utils/skeletonDelay';

export const useDelayedVisible = (delayMs: number, key: string = 'default'): boolean => {
    const [remaining] = useState(() => getRemainingSkeletonDelay(key, delayMs));
    const [visible, setVisible] = useState(remaining === 0);

    useEffect(() => {
        const timer = remaining > 0 ? setTimeout(() => setVisible(true), remaining) : undefined;
        return () => {
            if (timer) clearTimeout(timer);
            markSkeletonSeen(key);
        };
    }, [remaining, key]);

    return visible;
};
